import React from 'react'
import { observer } from "mobx-react";
import { onSnapshot } from "mobx-state-tree";
import { Col, Row } from "antd";

import { FSelect, Option } from "../common/form";
import { Pets } from "../models/Book";

const idToTemplate = {
  "": "",
  "0": 1,
  "1": 2,
  "2": 3,
  "3": 4,
  "4": 5,
  "5": 6,
  "00": 7,
  "10": 8,
  "20": 9,
  "30": 10,
  "40": 11,
  "50": 12,
  "11": 13,
  "21": 14,
  "31": 15,
  "41": 16,
  "51": 17,
  "22": 18,
  "32": 19,
  "42": 20,
  "52": 21,
  "33": 22,
  "43": 23,
  "53": 24,
  "44": 25,
  "54": 26,
  "55": 27
};

const templateToId = {
  "": "",
  1: "0",
  2: "1",
  3: "2",
  4: "3",
  5: "4",
  6: "5",
  7: "00",
  8: "10",
  9: "20",
  10: "30",
  11: "40",
  12: "50",
  13: "11",
  14: "21",
  15: "31",
  16: "41",
  17: "51",
  18: "22",
  19: "32",
  20: "42",
  21: "52",
  22: "33",
  23: "43",
  24: "53",
  25: "44",
  26: "54",
  27: "55"
};


const PetTemplate = observer(({ pet, label }) => (
  <Row type="flex" justify="space-between">
    <Col span={11}>
      <div className="label">{label}</div>
      <FSelect
        defaultValue={pet.type}
        onChange={v => pet.changeType(v)}
        size="large"
      >
        <Option value={0}>犬</Option>
        <Option value={3}>猫</Option>
      </FSelect>
    </Col>
    <Col span={11}>
      <div className="label">ペットの毛色</div>
      <FSelect
        defaultValue={pet.color}
        onChange={v => pet.changeColor(v)}
        size="large"
      >
        <Option value={0}>ブラック系</Option>
        <Option value={1}>ホワイト系</Option>
        <Option value={2}>ブラウン系</Option>
      </FSelect>
    </Col>
  </Row>
));

class PetsTemplaceRender extends React.Component {
  constructor(props) {
    super(props);
    this.pets = Pets.create({});
    onSnapshot(this.pets, this.onChange);
  }

  componentWillMount() {
    if (this.props.book.petsTemplate) {
      let ids = templateToId[this.props.book.petsTemplate].split('');
      ids.forEach((v, k) => this.pets[`pet${k + 1}`].setUpFromId(parseInt(v)));
    }
  }

  componentWillReceiveProps() {
    this.onChange();
  }

  onChange = () => {
    this.props.book.changePetsTemplate(idToTemplate[this.pets.id(this.props.book.pets)]);
  }

  render() {
    const { pets } = this.props.book;
    let ret = [];
    for (let i = 0; i < pets; i++) {
      ret.push(
        <PetTemplate
          pet={this.pets[`pet${i + 1}`]}
          key={i}
          // label={pets === 1 ? 'お子様の年齢' : `${i + 1}人目のお子様の年齢`}
          label={'ペットの種類'}
        />
      );
    }
    return ret;
  }
}

export default observer(PetsTemplaceRender);



// WEBPACK FOOTER //
// ./src/components/PetsTemplateRender.js